'use client'

import s from './AccordionBlock.module.scss';
import {TAccordionBlockProps} from "@/app/[locale]/common/components/AccordionBlock/types";
import {CustomIconButton} from "@/app/[locale]/common/components/CustomIconButton/CustomIconButton";
import {ArrowIcon} from "@/app/[locale]/common/assets/ArrowIcon/ArrowIcon";
import {ConfirmIcon} from "@/app/[locale]/common/assets/ConfirmIcon/ConfirmIcon";

export const AccordionBlock = ({ isOpen, data, onClick }: TAccordionBlockProps) => {

    return (
        <div className={s.accordionBlock}>
            {
                data.map((item) => (
                    <div key={item.id} className={s.accordionBlock_card}>
                        <CustomIconButton
                            className={s.accordionBlock_trigger}
                            rightIcon={<ArrowIcon active={isOpen[item.id]} />}
                            onClick={() => onClick(item.id)}
                        >
                            { item.title }
                        </CustomIconButton>

                        {isOpen[item.id] &&
                            <div className={s.accordionBlock_container}>
                                <ul className={s.accordionBlock_list}>
                                    {item.items.map((point, index) => (
                                            <li key={index} className={s.accordionBlock_list_item}>
                                                <span><ConfirmIcon/></span>
                                                {point}
                                            </li>
                                        ))}
                                </ul>
                            </div>}
                    </div>
                ))
            }
        </div>
    );
};